export default __webpack_public_path__ + "static/media/vn-2.81651393.jpg";